import { trpc } from '@/services/trpc';

export function useClientSideFormToolMutation() {
  const utils = trpc.useUtils();

  const invalidate = async () => {
    await utils.clientSideFormTools.findAll.invalidate();
  };

  const create = trpc.clientSideFormTools.create.useMutation({
    onSuccess: invalidate,
  });

  const update = trpc.clientSideFormTools.update.useMutation({
    onSuccess: async (_data, variables) => {
      await Promise.all([
        invalidate(),
        utils.clientSideFormTools.findOne.invalidate({ id: variables.id }),
      ]);
    },
  });

  const remove = trpc.clientSideFormTools.delete.useMutation({
    onSuccess: invalidate,
  });

  return { create, update, remove };
}
